var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoadIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "21mm",
    height: "21mm",
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      fill: "#227dc0",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#227dc0",
      fillOpacity: 1,
      fillRule: "evenodd",
      strokeWidth: 0.58749288
    },
    d: "M1536.841 527.728c0-2.516 2.014-4.542 4.485-4.542a4.511 4.511 0 0 1 4.515 4.511c0 2.516-2.014 4.542-4.485 4.542a4.511 4.511 0 0 1-4.515-4.511z",
    transform: "translate(-558.553 -192.803) scale(.36932)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#227dc0",
      fillOpacity: 1,
      fillRule: "evenodd",
      strokeWidth: 0.58749288
    },
    d: "M1552.827 533.22a6.08 6.08 0 0 1-1.19 3.652l-7.108 9.85a4.029 4.029 0 0 1-6.528 0l-7.078-9.88a6.211 6.211 0 0 1 4.545-9.85v.674c0 .737.123 1.443.397 2.118-1.86.03-3.325 1.565-3.294 3.437 0 .705.244 1.38.64 1.933l3.02 4.204 1.8 2.485 2.227 3.13c.397.553 1.16.675 1.709.277h.03c.092-.062.184-.154.275-.277l2.258-3.13 1.769-2.485 3.05-4.204a3.376 3.376 0 0 0-.762-4.726 3.393 3.393 0 0 0-1.83-.644c.274-.675.396-1.381.426-2.118 0-.214-.03-.46-.03-.675a6.254 6.254 0 0 1 5.674 6.23zm-36.242 15.896c-2.379-.767-3.66-3.345-2.898-5.708a4.499 4.499 0 0 1 5.674-2.915c2.35.767 3.661 3.314 2.899 5.708-.763 2.393-3.295 3.713-5.675 2.915 0 .03 0 0 0 0z",
    transform: "translate(-558.553 -192.803) scale(.36932)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#227dc0",
      fillOpacity: 1,
      fillRule: "evenodd",
      strokeWidth: 0.58749288
    },
    d: "M1526.897 535.307a6.136 6.136 0 0 1 3.08 2.24l7.109 9.82c1.342 1.81.976 4.357-.824 5.677-.366.276-.732.46-1.16.614l-11.53 3.743a6.165 6.165 0 0 1-7.78-4.02 6.16 6.16 0 0 1-.122-3.406c.214.092.427.184.64.246.672.215 1.404.337 2.136.276-.518 1.78.488 3.682 2.258 4.204.64.184 1.342.184 2.013-.03l4.912-1.596 2.928-.952 3.692-1.227c.64-.215 1.006-.92.793-1.565a.724.724 0 0 0-.183-.338l-2.258-3.13-1.83-2.485-3.05-4.204a3.347 3.347 0 0 0-4.699-.737c-.549.4-.945.92-1.19 1.565a5.373 5.373 0 0 0-1.89-1.012 19.873 19.873 0 0 0-.672-.184 6.131 6.131 0 0 1 7.596-3.468l.031-.03zm3.63 39.523c-1.465 2.026-4.271 2.487-6.285 1.014a4.539 4.539 0 0 1-1.006-6.322c1.464-2.025 4.27-2.485 6.284-1.012a4.539 4.539 0 0 1 1.007 6.32z",
    transform: "translate(-558.553 -192.803) scale(.36932)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#227dc0",
      fillOpacity: 1,
      fillRule: "evenodd",
      strokeWidth: 0.58749288
    },
    d: "M1520.887 560.807a5.963 5.963 0 0 1 3.08-2.24l11.502-3.743c2.135-.675 4.393.49 5.094 2.639.122.399.183.797.183 1.227v12.182a6.21 6.21 0 0 1-6.162 6.23 6.24 6.24 0 0 1-3.295-.952c.153-.184.305-.337.428-.552a5.783 5.783 0 0 0 .915-1.964 3.325 3.325 0 0 0 4.667-.828 3.45 3.45 0 0 0 .61-1.934V558.69c0-.675-.549-1.227-1.22-1.227-.122 0-.244.03-.366.061l-3.66 1.197-2.93 1.012-4.91 1.565a3.347 3.347 0 0 0-1.679 1.228 3.363 3.363 0 0 0 .64 4.633c-.61.4-1.128.89-1.555 1.473a9.898 9.898 0 0 0-.366.583c-2.44-2.178-2.837-5.8-.976-8.408zm38.285 8.715c1.464 2.026 1.037 4.849-.976 6.322a4.472 4.472 0 0 1-6.284-.982c-1.465-2.026-1.038-4.849.976-6.322 2.013-1.503 4.82-1.043 6.284.982z",
    transform: "translate(-558.553 -192.803) scale(.36932)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#227dc0",
      fillOpacity: 1,
      fillRule: "evenodd",
      strokeWidth: 0.58749288
    },
    d: "M1543.126 574.463c-.763-1.074-1.19-2.332-1.19-3.652V558.63c0-2.24 1.77-4.05 3.996-4.082.427 0 .855.062 1.251.185l11.5 3.743c3.234 1.044 5.004 4.542 3.967 7.825a6.325 6.325 0 0 1-1.922 2.854 9.63 9.63 0 0 0-.366-.583c-.427-.583-.946-1.105-1.556-1.473a3.395 3.395 0 0 0 .671-4.726 3.338 3.338 0 0 0-1.647-1.166l-4.912-1.595-2.928-.952-3.661-1.196c-.64-.215-1.342.153-1.556.797a1.524 1.524 0 0 0-.06.369v12.182c.03.706.243 1.38.67 1.933a3.328 3.328 0 0 0 4.576.86c.183.705.488 1.35.915 1.933.122.184.275.368.428.552-2.716 1.657-6.285.951-8.176-1.626zm19.798-33.939a4.486 4.486 0 0 1 5.674 2.915c.763 2.394-.518 4.94-2.898 5.708a4.486 4.486 0 0 1-5.674-2.915c-.763-2.363.55-4.94 2.898-5.708z",
    transform: "translate(-558.553 -192.803) scale(.36932)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#227dc0",
      fillOpacity: 1,
      fillRule: "evenodd",
      strokeWidth: 0.58749288
    },
    d: "M1562.833 557.37a6.225 6.225 0 0 1-3.814 0l-11.5-3.774a4.079 4.079 0 0 1-2.593-2.608 4.039 4.039 0 0 1 .58-3.621l7.107-9.85c2.013-2.762 5.857-3.376 8.603-1.381a6.095 6.095 0 0 1 2.105 2.7 2.74 2.74 0 0 0-.671.184c-.672.215-1.312.583-1.892 1.013a3.368 3.368 0 0 0-4.21-2.117 3.347 3.347 0 0 0-1.677 1.227l-3.051 4.204-1.8 2.516-2.257 3.13c-.397.553-.275 1.32.274 1.75.091.091.214.122.336.183l3.66 1.197 2.93.952 4.91 1.595c1.77.583 3.661-.399 4.24-2.148.214-.644.214-1.32.03-1.964a6.294 6.294 0 0 0 2.136-.276c.214-.061.427-.153.64-.245a6.178 6.178 0 0 1-4.087 7.334z",
    transform: "translate(-558.553 -192.803) scale(.36932)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadIcon);
export default __webpack_public_path__ + "static/media/load-icon.202b8d349721eae2087e4367b18421cb.svg";
export { ForwardRef as ReactComponent };